<template>
	<svg width="9.998535" height="10.000000" viewBox="0 0 9.99854 10" fill="none" xmlns="http://www.w3.org/2000/svg" >
		<path
			d="M4.23 10L5.76 10L5.76 5.74L9.99 5.74L9.99 4.25L5.76 4.25L5.76 0L4.23 0L4.23 4.25L0 4.25L0 5.74L4.23 5.74L4.23 10Z"
			fill="#F2F7FF"
			fill-opacity="1.000000"
			fill-rule="nonzero"
		/>
	</svg>
</template>
